import { isRejectedWithValue } from "@reduxjs/toolkit";
import { setError } from "features/error/error";
import store from "store";
import { toast } from 'react-toastify';

/**
 * Log a warning and show a toast!
 */
const existNotAcceptableWords = ['MongoId', 'GET', '/m/'];
const ngrokRelatedErrors = ['ngrok', 'tunnel', 'cors', 'ERR_BLOCKED_BY_CLIENT', 'ERR_NETWORK'];

function doesMessageIncludeUnacceptableWords(message) {
  if (Array.isArray(message)) {
    return existNotAcceptableWords.some((word) => message[0].toLowerCase().includes(word.toLowerCase()));
  } else {
    return existNotAcceptableWords.some((word) => message?.toLowerCase().includes(word.toLowerCase()));
  }
}

function isNgrokRelatedError(message) {
  const messageStr = Array.isArray(message) ? message[0] : message;
  return ngrokRelatedErrors.some((keyword) => 
    messageStr?.toLowerCase().includes(keyword.toLowerCase())
  );
}

export const rtkQueryErrorLogger = () => (next) => (action) => {
  if (isRejectedWithValue(action)) {
    const showDefaultError =
      action.payload.status === 500 || doesMessageIncludeUnacceptableWords(action?.payload?.data?.message);
    
    const isNgrokError = isNgrokRelatedError(action?.payload?.data?.message);
    
    const defaultError = 'Oops! Something went wrong';
    const ngrokError = 'Network connectivity issue. Please check your connection and try again.';
    
    const message = isNgrokError
      ? ngrokError
      : showDefaultError
        ? defaultError
        : (action?.payload?.data?.message || defaultError);
    const toastMessage = Array.isArray(message) ? message.join(", ") : message;

    if (isNgrokError) {
      console.error('Ngrok/Network error detected:', action?.payload?.data?.message);
    }

    toast.error(toastMessage, { toastId: toastMessage });
  }
  return next(action);
};

// Additional helper function to handle script loading errors
export const handleScriptLoadingError = (error, scriptSrc) => {
  console.error('Script loading error:', error);
  
  if (scriptSrc?.includes('ngrok') || error?.message?.includes('ngrok')) {
    toast.error('Unable to load payment services. Please check your connection and try again.');
  } else if (error?.message?.includes('CORS')) {
    toast.error('Payment service configuration issue. Please contact support.');
  } else {
    toast.error('Unable to load payment services. Please refresh the page and try again.');
  }
};